var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTfNsw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "63px",
    viewBox: "0 0 92 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.0142045,0.383522727 C20.9659091,3.00426136 7.67045455,14.765625 0.191761364,23.5227273 C0.0639204545,23.6505682 -3.63345717e-14,23.7784091 -3.63345717e-14,23.90625 L-3.63345717e-14,23.90625 L-3.63345717e-14,23.90625 C-3.63345717e-14,24.2258523 0.255681818,24.4815341 0.575284091,24.4815341 C0.703125,24.4815341 0.767045455,24.4815341 0.830965909,24.4176136 L0.894886364,24.3536932 C8.88494318,17.1946023 21.9886364,7.15909091 39.1193182,7.99005682 C45.7670455,8.30965909 51.8394886,10.4190341 57.3366477,13.5511364 C63.0255682,16.8110795 73.6363636,27.5497159 73.6363636,27.5497159 C75.3622159,29.3394886 77.7911932,30.4261364 80.4119318,30.4261364 C80.4119318,30.4261364 81.9460227,30.4261364 83.2244318,29.9786932 C83.6079545,29.8508523 83.7997159,29.7869318 83.7997159,29.7869318 C84.5667614,29.4673295 88.9133523,27.3579545 88.2741477,21.796875 C88.0184659,19.5596591 86.9318182,17.2585227 84.8224432,15.2769886 C84.375,14.8934659 71.2073864,0 46.1505682,0 C44.1690341,0.0639204545 42.1875,0.191761364 40.0142045,0.383522727",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0199645402%",
    y1: "50.0685371%",
    x2: "99.3363245%",
    y2: "50.0685371%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1A3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E3A",
    offset: "1.415071%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0412F",
    offset: "15.45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F25B27",
    offset: "28.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36B23",
    offset: "40.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37021",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57E1E",
    offset: "62.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA317",
    offset: "87.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB913",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.8153409 C0,19.8153409 0,19.8792614 0,19.8792614 C0,20.1988636 0.255681818,20.4545455 0.575284091,20.4545455 C0.830965909,20.4545455 1.08664773,20.2627841 1.15056818,20.0071023 C1.15056818,20.0071023 1.15056818,19.9431818 1.15056818,19.9431818 C3.32386364,10.0355114 4.66619318,6.58380682 6.58380682,6.45596591 C10.9943182,6.26420455 15.0213068,26.015625 15.0213068,26.015625 C15.0852273,26.2713068 15.2769886,26.3991477 15.46875,26.4630682 C15.7244318,26.5269886 16.0440341,26.3991477 16.171875,26.0795455 C16.171875,26.0795455 16.2357955,25.9517045 16.171875,25.8238636 C16.171875,25.7599432 16.171875,25.6321023 16.171875,25.6321023 C13.1036932,6.20028409 10.0994318,0 7.54261364,0 C3.25994318,0 0.255681818,17.0667614 0,19.8153409",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.116402767%",
    y1: "49.9303682%",
    x2: "100.022416%",
    y2: "49.9303682%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C441",
    offset: "13.05%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC045",
    offset: "33.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B94D",
    offset: "59.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B057",
    offset: "89.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AC5B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.2096905,0.703125 C27.817645,2.30113636 22.8318495,7.79829545 18.8048609,13.1676136 C7.93838363,27.6136364 1.54633818,54.84375 0.0122472682,60.8522727 C-0.0516731863,61.2357955 0.140088177,61.4914773 0.45969045,61.5553977 C0.715372268,61.6193182 1.03497454,61.4914773 1.16281545,61.171875 C1.99378136,57.9758523 4.29491772,50.1775568 5.38156545,47.109375 C8.9611109,36.7542614 19.7636677,17.7059659 31.3971905,17.8338068 C46.80202,17.9616477 54.2167927,46.5340909 56.3261677,54.4602273 C57.348895,58.4872159 61.1202018,61.4914773 65.4667927,61.5553977 C70.70827,61.5553977 74.9909405,57.3366477 74.9909405,52.0951705 C74.9909405,51.6477273 74.92702,50.2414773 74.6074177,48.7713068 C74.0960541,46.5980114 63.67702,0 39.1954859,0 C37.5974745,0.0639204545 35.9355427,0.319602273 34.2096905,0.703125",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0244987234%",
    y1: "50.0407892%",
    x2: "99.8356746%",
    y2: "50.0407892%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEC",
    offset: "3.620642%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094D7",
    offset: "26.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081C8",
    offset: "49.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076BF",
    offset: "74.07%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072BC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TfNSW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.556814, -0.113296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 31.129261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -1.81672859e-14,
    y: 0.0639204545,
    width: 88.9772727,
    height: 30.4261364
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 35.156250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-5)",
    x: 0,
    y: 3.63345717e-14,
    width: 16.171875,
    height: 26.5269886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(15.009060, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_7_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    x: -0.0516731863,
    y: 0.0639204545,
    width: 75.1065341,
    height: 61.5553977
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5071023,52.0951705 C87.5071023,55.9943182 84.3110795,59.1264205 80.4119318,59.1264205 C76.5127841,59.1264205 73.3806818,55.9303977 73.3806818,52.03125 C73.3806818,48.1321023 76.5767045,44.9360795 80.4758523,45 C84.375,45 87.5071023,48.1960227 87.5071023,52.0951705",
    id: "Path",
    fill: "#00B3F0",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfNsw);
export default __webpack_public_path__ + "static/media/TfNSW.f3c5965a.svg";
export { ForwardRef as ReactComponent };